"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Locale = exports.CustomBrandNameContext = exports.defaultLanguage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable prefer-destructuring */
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var lz_string_1 = require("lz-string");
var network_utils_1 = require("network-utils");
var locales_1 = __importDefault(require("./locales"));
var dynamicContent_1 = __importDefault(require("./dynamicContent"));
exports.defaultLanguage = 'en';
// eslint-disable-next-line import/no-mutable-exports
exports.CustomBrandNameContext = (0, react_1.createContext)('');
var getTranslationsfromLocalStorage = function (locale) {
    return JSON.parse((0, lz_string_1.decompress)(localStorage.getItem(locale) || '{}') || '{}');
};
var I18nProvider = function (props) {
    var children = props.children, userLocale = props.userLocale, useUserLocale = props.useUserLocale, getContentTranslations = props.getContentTranslations, userToken = props.userToken, messages = props.messages, setMessages = props.setMessages, preloadContentTranslations = props.preloadContentTranslations, customBrandName = props.customBrandName;
    var getTranslationSha1 = network_utils_1.contentService.getTranslationSha1, getTranslations = network_utils_1.contentService.getTranslations;
    var defaultLocalTranslations = __assign(__assign({}, locales_1.default[exports.defaultLanguage]), dynamicContent_1.default[exports.defaultLanguage]);
    var calcLocale = function () { return (useUserLocale ? userLocale : exports.defaultLanguage); };
    var _a = (0, react_1.useState)(calcLocale()), locale = _a[0], setLocale = _a[1];
    var _b = (0, react_1.useState)(false), userLocaleMessagesSet = _b[0], setUserLocaleMessagesSet = _b[1];
    var _c = (0, react_1.useState)({
        en: {},
        pt: {},
        es: {},
        fr: {},
        ko: {},
        ja: {},
        de: {},
    }), translationsPerLocale = _c[0], setTranslationsPerLocale = _c[1];
    var getLocalTranslations = function (calculatedLocale) {
        if (customBrandName) {
            exports.CustomBrandNameContext = (0, react_1.createContext)(customBrandName);
        }
        return __assign(__assign({}, defaultLocalTranslations), __assign(__assign({}, locales_1.default[calculatedLocale || locale]), dynamicContent_1.default[calculatedLocale || locale]));
    };
    (0, react_1.useEffect)(function () {
        if (customBrandName) {
            exports.CustomBrandNameContext = (0, react_1.createContext)(customBrandName);
        }
        if ((getContentTranslations || preloadContentTranslations) && userLocale && userToken)
            getTranslationData();
    }, [userLocale, userToken]);
    (0, react_1.useEffect)(function () {
        if (customBrandName) {
            exports.CustomBrandNameContext = (0, react_1.createContext)(customBrandName);
        }
        var calculatedLocale = calcLocale();
        setLocale(calculatedLocale);
        var doSetMessages = getContentTranslations &&
            useUserLocale &&
            Object.keys(messages || {}).length !== 0 &&
            userLocale !== exports.defaultLanguage &&
            !userLocaleMessagesSet;
        if (doSetMessages) {
            var mergedTranslations = mergeTranslations(translationsPerLocale[exports.defaultLanguage], translationsPerLocale[calculatedLocale]);
            setUserLocaleMessagesSet(true);
            setMessages === null || setMessages === void 0 ? void 0 : setMessages(__assign(__assign({}, mergedTranslations), getLocalTranslations(calculatedLocale)));
        }
    }, [useUserLocale, userLocale, messages, customBrandName]);
    var getTranslationData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var defaultLanguageMessages, updateDefaultLanguagePromise, updateUserLocalePromise, translationMessages;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updateDefaultLanguagePromise = updateLocalStorage(exports.defaultLanguage);
                    if (!(userLocale !== exports.defaultLanguage)) return [3 /*break*/, 2];
                    updateUserLocalePromise = updateLocalStorage(userLocale);
                    return [4 /*yield*/, Promise.all([updateDefaultLanguagePromise, updateUserLocalePromise])];
                case 1:
                    translationMessages = _a.sent();
                    defaultLanguageMessages = translationMessages[0];
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, updateDefaultLanguagePromise];
                case 3:
                    defaultLanguageMessages = _a.sent();
                    _a.label = 4;
                case 4:
                    if (!preloadContentTranslations) {
                        setMessages === null || setMessages === void 0 ? void 0 : setMessages(__assign(__assign({}, defaultLanguageMessages), getLocalTranslations()));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var mergeTranslations = function (translation1, translation2) {
        var tempTranslation = __assign({}, translation2);
        Object.keys(tempTranslation).forEach(function (key) {
            if (!tempTranslation[key] && key)
                tempTranslation[key] = translation1[key];
        });
        return __assign(__assign({}, translation1), tempTranslation);
    };
    var updateLocalStorage = function (locale) { return __awaiter(void 0, void 0, void 0, function () {
        var translationsResult, localTranslationSha, localLocaleFile, serverTranslationSha, translation;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    localTranslationSha = localStorage.getItem("sha1_".concat(locale)) || '';
                    localLocaleFile = getTranslationsfromLocalStorage(locale);
                    return [4 /*yield*/, getTranslationSha1(userToken, locale)];
                case 1:
                    serverTranslationSha = _a.sent();
                    if (!(serverTranslationSha.sha1 !== localTranslationSha || Object.keys(localLocaleFile).length === 0)) return [3 /*break*/, 3];
                    return [4 /*yield*/, getTranslations(userToken, locale)];
                case 2:
                    translation = _a.sent();
                    translationsResult = translation.messages;
                    setTranslationsPerLocale(function (prev) {
                        var _a;
                        return (__assign(__assign({}, prev), (_a = {}, _a[locale] = translationsResult, _a)));
                    });
                    setInLocalStorage(translation.messages, serverTranslationSha.sha1, locale);
                    return [3 /*break*/, 4];
                case 3:
                    translationsResult = localLocaleFile;
                    setTranslationsPerLocale(function (prev) {
                        var _a;
                        return (__assign(__assign({}, prev), (_a = {}, _a[locale] = translationsResult, _a)));
                    });
                    _a.label = 4;
                case 4: return [2 /*return*/, translationsResult];
            }
        });
    }); };
    var setInLocalStorage = function (messages, sha1, locale) {
        localStorage.setItem(locale, (0, lz_string_1.compress)(JSON.stringify(messages)));
        localStorage.setItem("sha1_".concat(locale), sha1);
    };
    return ((0, jsx_runtime_1.jsx)(react_intl_1.IntlProvider, __assign({ locale: locale || exports.defaultLanguage, messages: getContentTranslations ? messages : getLocalTranslations(locale) }, { children: children }), void 0));
};
var Locale;
(function (Locale) {
    Locale[Locale["en"] = 0] = "en";
    Locale[Locale["fr"] = 1] = "fr";
    Locale[Locale["es"] = 2] = "es";
    Locale[Locale["de"] = 3] = "de";
    Locale[Locale["pt"] = 4] = "pt";
    Locale[Locale["ja"] = 5] = "ja";
    Locale[Locale["ko"] = 6] = "ko";
})(Locale = exports.Locale || (exports.Locale = {}));
exports.default = I18nProvider;
